module.exports = __webpack_public_path__ + "static/img/ls10.5028ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls10.png
// module id = mwcp
// module chunks = 12